import React from "react";
import "../css/SubmitQuoteForm.css";
import ContactForm from "./ContactForm";

const SubmitQuoteForm = () => {
  return (
    <div className="submit-quote-wrapper">
      <div className="submit-quote-container">
        <div className="submit-quote-grid">
          <div className="column">
            <ContactForm />
          </div>
          <div className="column">
            <section className="locations">
              <h2>Our Locations</h2>

              <div className="location">
                <h3>Main Office</h3>
                <p>7625 W New York St, Indianapolis, IN 46214</p>
                <p>Phone: (317) 273-6960</p>
                <p>Hours: Mon-Fri, 8 AM - 5 PM EST</p>
              </div>
            </section>
          </div>
          <div className="column">
            <div className="new-visit-button">
              <h2>New Visitors</h2>
              <p className="visitor-p">Please call ahead of time to arrange a visit to Flotec.</p>
            </div>
            <hr />
            <h2>Distributors</h2>
            <p className="supplier-p">If you are interested in becoming a distributor give us a call or fill out our contact form and we will get in touch.</p>
          </div>
        </div>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3066.62486026681!2d-86.29804968793398!3d39.770530394596356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886ca8628a5a69b7%3A0x1efd4bb4ad22932c!2sFlotec%20Inc!5e0!3m2!1sen!2sus!4v1723818025536!5m2!1sen!2sus"
            width="100%"
            height="400"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Google Map of Flotec Inc"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default SubmitQuoteForm;
